import { getContext } from '@fiverr-private/fiverr_context';
import {
    getBackgroundCheckResultFile as getBackgroundCheckResultFileRequest,
    getOrganizationComplianceData,
} from '../api';

export const useComplianceApi = () => {
    const { organizationId, userId } = getContext();

    const getCompliance = async (sellerIds?: number[]) => {
        if (!organizationId) {
            return;
        }
        const body = await getOrganizationComplianceData(organizationId, sellerIds);
        return body;
    };

    const getBackgroundCheckResultFile = async ({ externalVendorId }: { externalVendorId: string }) => {
        if (!userId || !organizationId) {
            return;
        }
        return getBackgroundCheckResultFileRequest({
            requester_id: userId,
            externalVendorId,
        });
    };

    return {
        getCompliance,
        getBackgroundCheckResultFile,
    };
};
